import React, { useState, useEffect } from "react";
import Slider from "react-slick";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSnowflake, faBed, faUtensils } from "@fortawesome/free-solid-svg-icons";
import FilterCar from "./FilterCar";
import Filter from "./Filter";
import FilterLux from "./FilterLux";

// Import banner images
import DefaultBanner from "../img/aaaservices/banner1.jpg";
import MiniBanner from "../img/aaaservices/banner1.jpg";
import LargeBanner from "../img/aaaservices/baiinersuite.jpg";
import MediumBanner from "../img/aaaservices/BANQETHALL.jpeg";

const FleetPage = () => {
  const [selectedBanner, setSelectedBanner] = useState(DefaultBanner);
  const [selectedFilter, setSelectedFilter] = useState(null);
  const [bannerText, setBannerText] = useState("Welcome to Our Hotel");

  const bannerContent = {
    COMMERCIAL_INTERIORS: {
      image: MiniBanner,
      text: "Experience Cool Comfort in Our AC Rooms",
    },
    HOSPITALITY_INTERIORS: {
      image: LargeBanner,
      text: "Indulge in Luxury and Comfort",
    },
    SHOWCASE_INTERIORS: {
      image: MediumBanner,
      text: "Celebrate Your Special Events in Style",
    },
  };

  const handleFilterClick = (type) => {
    setSelectedFilter(type);
    setSelectedBanner(bannerContent[type]?.image || DefaultBanner);
    setBannerText(bannerContent[type]?.text || "Welcome to Our Hotel");
  };

  useEffect(() => {
    console.log("Banner changed:", selectedBanner);
  }, [selectedBanner]);

  const renderContent = () => {
    switch (selectedFilter) {
      case "COMMERCIAL_INTERIORS":
        return <FilterCar />;
      case "HOSPITALITY_INTERIORS":
        return <Filter />;
      case "SHOWCASE_INTERIORS":
        return <FilterLux />;
      default:
        return <FilterCar />;
    }
  };

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div>
      {/* Dynamic Banner */}
      <div
        key={selectedBanner}
        className="banner-container"
        style={{
          width: "100%",
          height: "500px",
          marginTop: "92px",
          backgroundImage: `url(${selectedBanner})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          overflow: "hidden",
          
        }}
      >

<div
    style={{
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      backgroundColor: "rgba(0, 0, 0, 0.5)", // Dark overlay with 50% opacity
    }}
  ></div>
        {/* Animated Text */}
        <h1 className="banner-text">{bannerText}</h1>
      </div>

      

      {/* Filter Slider */}
      <div
        className="icon-slider-wrapper"
        style={{
          position: "sticky",
          top: "96px",
          backgroundColor: "#ffff",
          zIndex: 997,
          boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
          height: "96px",
          width: "100%",
          marginTop: "5px",
        }}
      >
        <Slider {...settings}>
          {[
            { type: "COMMERCIAL_INTERIORS", icon: faSnowflake, label: "Rooms" },
            { type: "HOSPITALITY_INTERIORS", icon: faBed, label: "Restaurant" },
            { type: "SHOWCASE_INTERIORS", icon: faUtensils, label: "Banquet Hall" },
          ].map((item) => (
            <div key={item.type} style={{ textAlign: "center" }}>
              <a
                className="filter"
                onClick={() => handleFilterClick(item.type)}
                style={{
                  textDecoration: "none",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                   marginTop: "33px",
                  cursor: "pointer",
                }}
              >
                <FontAwesomeIcon icon={item.icon} style={{ marginBottom: "5px", fontSize: "24px" }} />
                <p>{item.label}</p>
              </a>
            </div>
          ))}
        </Slider>
      </div>

      {/* Dynamic Content Section */}
      <div
        className="dynamic-content-section"
        style={{
          padding: "20px",
          background: "#f8f9fa",
          borderRadius: "10px",
        }}
      >
        {renderContent()}
      </div>

      {/* CSS for animations */}
      <style>
        {`
       @keyframes textAppear {
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
   
  }
}
  .overlay {
          background: rgba(0, 0, 0, 0.5);
          padding: 20px;
          color: #fff;
          width: 100%;
        }

.banner-text {
  font-size: 25px;
  font-weight: bold;
  color: white;
  text-align: center;
  position: absolute;
  animation: textAppear 1.5s ease-in-out forwards;
}
        `}
      </style>
    </div>
  );
};

export default FleetPage;







